<template>
    <div class="landing">
        <nav class="navbar navbar-expand-lg navbar-dark fixed-top">
            <div class="container">
                <a class="navbar-brand" href="#inicio">
                    <img src="@/assets/viewlanding/Logos/Logo y Marca Color.png" alt="Refugio Napostá"
                        style="height: 40px; width: auto;">
                </a>

                <button class="navbar-toggler border-soft" type="button" data-bs-toggle="collapse"
                    data-bs-target="#mainNav">
                    <span class="navbar-toggler-icon"></span>
                </button>

                <div class="collapse navbar-collapse" id="mainNav">
                    <ul class="navbar-nav mx-auto mb-2 mb-lg-0">
                        <li class="nav-item"><a class="nav-link" href="#nosotros">Nosotros</a></li>
                        <li class="nav-item"><a class="nav-link" href="#experiencias">Experiencias</a></li>
                        <li class="nav-item"><a class="nav-link" href="#tarifas">Tarifas</a></li>
                        <li class="nav-item"><a class="nav-link" href="#reservas">Reservas</a></li>
                        <li class="nav-item"><a class="nav-link" href="#traslado">Traslado</a></li>
                        <li class="nav-item"><a class="nav-link" href="#como-llegar">Cómo llegar</a></li>
                    </ul>

                    <div class="d-flex gap-2">
                        <a class="btn btn-accent" href="#reservas">Reservar / Consultar</a>
                    </div>
                </div>
            </div>
        </nav>

        <!-- HERO -->
        <section id="inicio" class="hero position-relative overflow-hidden">

            <!-- DESKTOP: video de fondo (md+) -->
            <div class="video-bg d-none d-md-block">
                <iframe
                    src="https://www.youtube.com/embed/bJAOfwsqSAs?autoplay=1&mute=1&loop=1&playlist=bJAOfwsqSAs&controls=0&rel=0&modestbranding=1&playsinline=1"
                    title="Refugio Napostá" frameborder="0" allow="autoplay; fullscreen" allowfullscreen>
                </iframe>
            </div>
            <div class="hero-overlay d-none d-md-block"></div>

            <!-- Contenido DESKTOP -->
            <div class="container position-relative z-2 text-center d-none d-md-flex flex-column"
                style="min-height: calc(100vh - 67px);">
                <div class="d-flex justify-content-center gap-2 flex-wrap mb-3">
                    <span class="chip"><span class="dot"></span> 30 camas</span>
                    <span class="chip"><span class="dot"></span> 30+ km de senderos</span>
                    <span class="chip"><span class="dot"></span> Duchas 24 hs</span>
                    <span class="chip"><span class="dot"></span> Leña incluida</span>
                </div>

                <!--
                    <h1 class="display-2 fw-bold mb-3" style="line-height:.95">Refugio Napostá</h1>
                    <p class="lead text-muted-2 mb-4" style="max-width: 900px; margin: 0 auto;">
                        Camping y albergue de montaña en Sierra de la Ventana, al pie del Cerro Tres Picos.
                    </p>

                    <div class="d-flex justify-content-center gap-2 flex-column flex-sm-row">
                        <a href="#reservas" class="btn btn-accent btn-lg px-4">Reservar / Consultar</a>
                        <a href="#experiencias" class="btn btn-ghost btn-lg px-4">Ver experiencias</a>
                    </div>
                    -->
            </div>

            <!-- MOBILE: video arriba + texto abajo -->
            <div class="hero-mobile d-block d-md-none">
                <div class="hero-mobile-video">
                    <div class="ratio ratio-16x9 yt-cover">
                        <iframe
                            src="https://www.youtube.com/embed/bJAOfwsqSAs?autoplay=1&mute=1&loop=1&playlist=bJAOfwsqSAs&controls=0&rel=0&modestbranding=1&playsinline=1"
                            title="Refugio Napostá" frameborder="0" allow="autoplay; fullscreen"
                            allowfullscreen></iframe>
                    </div>
                </div>

                <div class="container py-4 text-center">
                    <div class="d-flex justify-content-center gap-2 flex-wrap mb-3">
                        <span class="chip"><span class="dot"></span> 30 camas</span>
                        <span class="chip"><span class="dot"></span> 30+ km senderos</span>
                        <span class="chip"><span class="dot"></span> Duchas 24 hs</span>
                    </div>

                    <h1 class="display-5 fw-bold mb-2">Refugio Napostá</h1>
                    <p class="text-muted-2 mb-3">
                        Camping y albergue de montaña en Sierra de la Ventana, al pie del Cerro Tres Picos.
                    </p>

                    <div class="d-grid gap-2">
                        <a href="#reservas" class="btn btn-accent btn-lg">Reservar / Consultar</a>
                        <a href="#experiencias" class="btn btn-ghost btn-lg">Ver experiencias</a>
                    </div>
                </div>
            </div>

        </section>


        <!-- HIGHLIGHTS -->
        <section class="py-5 topo-sep">
            <div class="container py-3">
                <div class="row g-4">
                    <div class="col-12 col-lg-4">
                        <div class="p-4 bg-panel border-soft rounded-2xl shadow-soft h-100">
                            <div class="d-flex align-items-center gap-2 mb-2">
                                <span class="d-inline-block rounded-circle"
                                    style="width:10px;height:10px;background:var(--accent)"></span>
                                <h3 class="h4 mb-0">Naturaleza pura</h3>
                            </div>
                            <p class="text-muted-2 mb-0">
                                Un entorno de montaña real, lejos del ruido, para desconectar y vivir la
                                experiencia al aire libre.
                            </p>
                        </div>
                    </div>

                    <div class="col-12 col-lg-4">
                        <div class="p-4 bg-panel border-soft rounded-2xl shadow-soft h-100">
                            <div class="d-flex align-items-center gap-2 mb-2">
                                <span class="d-inline-block rounded-circle"
                                    style="width:10px;height:10px;background:var(--accent2)"></span>
                                <h3 class="h4 mb-0">30+ km de senderos</h3>
                            </div>
                            <p class="text-muted-2 mb-0">
                                Al inicio de recorridos para explorar quebradas, arroyos, piletones y cuevas con
                                formas increíbles.
                            </p>
                        </div>
                    </div>

                    <div class="col-12 col-lg-4">
                        <div class="p-4 bg-panel border-soft rounded-2xl shadow-soft h-100">
                            <div class="d-flex align-items-center gap-2 mb-2">
                                <span class="d-inline-block rounded-circle"
                                    style="width:10px;height:10px;background:var(--link)"></span>
                                <h3 class="h4 mb-0">Cerro Tres Picos</h3>
                            </div>
                            <p class="text-muted-2 mb-0">
                                Base ideal para conocer el cerro más alto y reconocido de la Provincia de Buenos
                                Aires.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </section>


        <!-- INSTALACIONES Y SERVICIOS -->
        <section id="servicios" class="py-5">
            <div class="container py-3">

                <div class="text-center mb-4">
                    <h2 class="display-5 mb-2">Instalaciones y Servicios</h2>
                    <p class="text-muted-2 mb-0" style="max-width: 820px; margin: 0 auto;">
                        Todo lo necesario para grupos y salidas de montaña: comodidad simple, funcional y lista
                        para usar.
                    </p>
                </div>

                <div class="row g-4">
                    <div class="col-12 col-md-6 col-lg-4">
                        <div class="p-4 bg-panel border-soft rounded-2xl h-100">
                            <h3 class="h5 mb-2">🏕️ Acampe</h3>
                            <p class="text-muted-2 mb-0">Amplio sector de acampe para grupos.</p>
                        </div>
                    </div>

                    <div class="col-12 col-md-6 col-lg-4">
                        <div class="p-4 bg-panel border-soft rounded-2xl h-100">
                            <h3 class="h5 mb-2">🛏️ Habitaciones</h3>
                            <p class="text-muted-2 mb-0">Camas cuchetas tipo refugio de montaña. <strong
                                    style="color:var(--text)">30 camas</strong> en total.</p>
                        </div>
                    </div>

                    <div class="col-12 col-md-6 col-lg-4">
                        <div class="p-4 bg-panel border-soft rounded-2xl h-100">
                            <h3 class="h5 mb-2">🔥 Salón</h3>
                            <p class="text-muted-2 mb-0">Amplio salón con mesas y bancos. Calefacción a leña con
                                salamandra.</p>
                        </div>
                    </div>

                    <div class="col-12 col-md-6 col-lg-4">
                        <div class="p-4 bg-panel border-soft rounded-2xl h-100">
                            <h3 class="h5 mb-2">💧 Agua potable</h3>
                            <p class="text-muted-2 mb-0">Disponibilidad de agua potable en el predio.</p>
                        </div>
                    </div>

                    <div class="col-12 col-md-6 col-lg-4">
                        <div class="p-4 bg-panel border-soft rounded-2xl h-100">
                            <h3 class="h5 mb-2">📶 Internet WiFi</h3>
                            <p class="text-muted-2 mb-0">Conectividad WiFi disponible (ideal para coordinación
                                de grupos).</p>
                        </div>
                    </div>

                    <div class="col-12 col-md-6 col-lg-4">
                        <div class="p-4 bg-panel border-soft rounded-2xl h-100">
                            <h3 class="h5 mb-2">🍳 Cocina equipada</h3>
                            <p class="text-muted-2 mb-0">
                                Hornos a leña y gas, heladeras, anafes, bachas con agua caliente y mesas.
                            </p>
                        </div>
                    </div>

                    <div class="col-12 col-md-6 col-lg-4">
                        <div class="p-4 bg-panel border-soft rounded-2xl h-100">
                            <h3 class="h5 mb-2">🧰 Set para grupos</h3>
                            <p class="text-muted-2 mb-0">
                                Ollas, tablas de madera, coladores, cuchillos, cucharones y más para cocinar en
                                grupo.
                            </p>
                        </div>
                    </div>

                    <div class="col-12 col-md-6 col-lg-4">
                        <div class="p-4 bg-panel border-soft rounded-2xl h-100">
                            <h3 class="h5 mb-2">🚿 Duchas + baños</h3>
                            <p class="text-muted-2 mb-0">
                                <strong style="color:var(--text)">4 duchas</strong> con agua caliente 24 hs
                                (anteducha/cambiador privado) y <strong style="color:var(--text)">4
                                    baños</strong>.
                            </p>
                        </div>
                    </div>

                    <div class="col-12 col-md-6 col-lg-4">
                        <div class="p-4 bg-panel border-soft rounded-2xl h-100">
                            <h3 class="h5 mb-2">🍖 Fogones</h3>
                            <p class="text-muted-2 mb-0">3 sectores de fogones con parrilla.</p>
                        </div>
                    </div>

                    <div class="col-12 col-md-6 col-lg-4">
                        <div class="p-4 bg-panel border-soft rounded-2xl h-100">
                            <h3 class="h5 mb-2">🏊 Tanque australiano</h3>
                            <p class="text-muted-2 mb-0">Uso recreativo (habilitado de <strong
                                    style="color:var(--text)">enero a marzo</strong>).</p>
                        </div>
                    </div>

                    <div class="col-12 col-md-6 col-lg-4">
                        <div class="p-4 bg-panel border-soft rounded-2xl h-100">
                            <h3 class="h5 mb-2">🪵 Leña incluida</h3>
                            <p class="text-muted-2 mb-0">Provisión gratuita de leña.</p>
                        </div>
                    </div>

                    <div class="col-12 col-md-6 col-lg-4">
                        <div class="p-4 bg-panel border-soft rounded-2xl h-100">
                            <h3 class="h5 mb-2">🧭 Base de senderos</h3>
                            <p class="text-muted-2 mb-0">Ubicado al pie de cerros y quebradas, ideal para
                                explorar el área.</p>
                        </div>
                    </div>
                </div>

                <div class="mt-4 p-4 border-soft rounded-2xl" style="background: rgba(255,106,0,.08);">
                    <div class="d-flex align-items-center gap-2 mb-2">
                        <span class="d-inline-block rounded-circle"
                            style="width:10px;height:10px;background:var(--accent)"></span>
                        <h3 class="h5 mb-0">No se incluye</h3>
                    </div>
                    <p class="text-muted-2 mb-0">
                        Proveeduría · Ropa de cama · Vajilla · Ollas pequeñas
                    </p>
                </div>

                <div class="mt-5 p-4 p-lg-5 bg-panel border-soft rounded-2xl shadow-soft text-center">
                    <h3 class="display-6 mb-2">¿Organizás una salida con tu grupo?</h3>
                    <p class="text-muted-2 mb-4" style="max-width: 820px; margin: 0 auto;">
                        Consultá disponibilidad y contanos cuántas personas son. Te respondemos para coordinar
                        fechas y condiciones.
                    </p>
                    <div class="d-flex justify-content-center gap-2 flex-column flex-sm-row">
                        <a href="#reservas" class="btn btn-accent btn-lg px-4">Consultar disponibilidad</a>
                        <a href="#experiencias" class="btn btn-ghost btn-lg px-4">Ver experiencias</a>
                    </div>
                </div>

            </div>
        </section>


        <!-- NOSOTROS -->
        <section id="nosotros" class="py-5">
            <div class="container py-3">

                <div class="row align-items-end g-4 mb-4">
                    <div class="col-12 col-lg-7">
                        <h2 class="display-5 mb-2">Nosotros</h2>
                        <p class="text-muted-2 mb-0">
                            El Refugio Napostá es un camping y albergue de montaña destinado a dar alojamientos
                            a grupos de scouts,
                            escuelas, institutos y montañistas. Su principal atractivo es la pureza de la
                            naturaleza que lo rodea:
                            al inicio de más de 30 km de senderos, al pie de quebradas y cerros relevantes de la
                            provincia de Buenos Aires,
                            entre ellos el Cerro Tres Picos.
                        </p>
                    </div>

                    <div class="col-12 col-lg-5">
                        <div class="p-4 bg-panel border-soft rounded-2xl h-100">
                            <div class="d-flex align-items-center gap-2 mb-3">
                                <span class="d-inline-block rounded-circle"
                                    style="width:10px;height:10px;background:var(--accent2)"></span>
                                <h3 class="h5 mb-0">Ficha rápida</h3>
                            </div>
                            <div class="row g-2">
                                <div class="col-6">
                                    <div class="p-3 border-soft rounded-2xl" style="background: rgba(255,255,255,.03);">
                                        <div class="text-muted-2" style="font-size:.9rem;">Capacidad</div>
                                        <div class="fw-semibold">30 camas</div>
                                    </div>
                                </div>
                                <div class="col-6">
                                    <div class="p-3 border-soft rounded-2xl" style="background: rgba(255,255,255,.03);">
                                        <div class="text-muted-2" style="font-size:.9rem;">Senderos</div>
                                        <div class="fw-semibold">30+ km</div>
                                    </div>
                                </div>
                                <div class="col-6">
                                    <div class="p-3 border-soft rounded-2xl" style="background: rgba(255,255,255,.03);">
                                        <div class="text-muted-2" style="font-size:.9rem;">Duchas</div>
                                        <div class="fw-semibold">24 hs</div>
                                    </div>
                                </div>
                                <div class="col-6">
                                    <div class="p-3 border-soft rounded-2xl" style="background: rgba(255,255,255,.03);">
                                        <div class="text-muted-2" style="font-size:.9rem;">Leña</div>
                                        <div class="fw-semibold">Incluida</div>
                                    </div>
                                </div>
                                <div class="col-12">
                                    <div class="p-3 border-soft rounded-2xl" style="background: rgba(255,255,255,.03);">
                                        <div class="text-muted-2" style="font-size:.9rem;">Tanque australiano
                                        </div>
                                        <div class="fw-semibold">Uso recreativo (Enero a Marzo)</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Carrusel -->
                <div class="p-3 p-lg-4 bg-panel border-soft rounded-2xl shadow-soft">
                    <div class="d-flex align-items-center justify-content-between mb-3">
                        <h3 class="h4 mb-0">Galería</h3>
                        <div class="text-muted-2" style="font-size:.95rem;">Deslizá para ver más</div>
                    </div>

                    <div id="carouselNosotros" class="carousel slide" data-bs-ride="carousel">
                        <div class="carousel-inner rounded-2xl overflow-hidden border-soft">
                            <div class="carousel-item active">
                                <img class="d-block w-100" alt="Nosotros 1" src="@/assets/viewlanding/Nosotros/1.jpeg">
                            </div>
                            <div class="carousel-item">
                                <img class="d-block w-100" alt="Nosotros 2" src="@/assets/viewlanding/Nosotros/2.jpeg">
                            </div>
                            <div class="carousel-item">
                                <img class="d-block w-100" alt="Nosotros 3" src="@/assets/viewlanding/Nosotros/3.jpeg">
                            </div>
                            <div class="carousel-item">
                                <img class="d-block w-100" alt="Nosotros 4" src="@/assets/viewlanding/Nosotros/4.jpeg">
                            </div>
                            <div class="carousel-item">
                                <img class="d-block w-100" alt="Nosotros 5" src="@/assets/viewlanding/Nosotros/5.jpeg">
                            </div>
                            <div class="carousel-item">
                                <img class="d-block w-100" alt="Nosotros 6" src="@/assets/viewlanding/Nosotros/6.jpeg">
                            </div>
                            <div class="carousel-item">
                                <img class="d-block w-100" alt="Nosotros 7" src="@/assets/viewlanding/Nosotros/7.jpeg">
                            </div>
                            <div class="carousel-item">
                                <img class="d-block w-100" alt="Nosotros 8" src="@/assets/viewlanding/Nosotros/8.jpg">
                            </div>
                        </div>

                        <button class="carousel-control-prev" type="button" data-bs-target="#carouselNosotros"
                            data-bs-slide="prev">
                            <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                            <span class="visually-hidden">Anterior</span>
                        </button>
                        <button class="carousel-control-next" type="button" data-bs-target="#carouselNosotros"
                            data-bs-slide="next">
                            <span class="carousel-control-next-icon" aria-hidden="true"></span>
                            <span class="visually-hidden">Siguiente</span>
                        </button>
                    </div>
                </div>

            </div>
        </section>


        <!-- EXPERIENCIAS -->
        <section id="experiencias" class="py-5 topo-sep">
            <div class="container py-3">

                <div class="text-center mb-4">
                    <h2 class="display-5 mb-2">Experiencias</h2>
                    <p class="text-muted-2 mb-0" style="max-width: 920px; margin: 0 auto;">
                        El Refugio Napostá está ubicado en un lugar preferencial, rodeado de cerros de distinta
                        altura y dificultad,
                        y cerca de nacientes de arroyos con piletones y cuevas. Dos senderos se destacan por la
                        belleza de sus recorridos.
                    </p>
                </div>

                <div class="row g-4">
                    <div class="col-12 col-lg-6">
                        <div class="p-4 p-lg-5 bg-panel border-soft rounded-2xl shadow-soft h-100">
                            <div class="d-flex align-items-center justify-content-between flex-wrap gap-2 mb-3">
                                <h3 class="h2 mb-0">Trekking al Cerro Tres Picos</h3>
                                <span class="badge rounded-pill"
                                    style="background: rgba(255,106,0,.18); border: 1px solid rgba(255,106,0,.35); color: var(--text);">
                                    Alta dificultad
                                </span>
                            </div>

                            <p class="text-muted-2">
                                El Cerro Tres Picos es el punto más alto de la Provincia de Buenos Aires.
                                Actividad intensa
                                de alta dificultad con duración estimada entre <strong style="color:var(--text)">8 y
                                    10 horas</strong>.
                            </p>

                            <div class="d-flex gap-2 flex-wrap mb-4">
                                <span class="chip"><span class="dot"></span> 8–10 hs</span>
                                <span class="chip"><span class="dot"></span> Actividad intensa</span>
                                <span class="chip"><span class="dot"></span> Guía o autoguiado</span>
                            </div>

                            <a href="https://drive.google.com/file/d/14siL30Br98rio2v-2iaEIDrZ0sTG2rK2/view?usp=sharing"
                                target="_blank" class="btn btn-accent btn-lg">Consultar salida</a>
                        </div>
                    </div>

                    <div class="col-12 col-lg-6">
                        <div class="p-4 p-lg-5 bg-panel border-soft rounded-2xl shadow-soft h-100">
                            <div class="d-flex align-items-center justify-content-between flex-wrap gap-2 mb-3">
                                <h3 class="h2 mb-0">Trekking a la Olla del Napostá</h3>
                                <span class="badge rounded-pill"
                                    style="background: rgba(76,201,166,.18); border: 1px solid rgba(76,201,166,.35); color: var(--text);">
                                    Baja dificultad
                                </span>
                            </div>

                            <p class="text-muted-2">
                                La Olla del Napostá es el piletón más importante de la quebrada donde nace el
                                Arroyo Napostá.
                                Actividad de baja dificultad con duración estimada entre <strong
                                    style="color:var(--text)">4 y 5 horas</strong>.
                            </p>

                            <div class="d-flex gap-2 flex-wrap mb-4">
                                <span class="chip"><span class="dot"></span> 4–5 hs</span>
                                <span class="chip"><span class="dot"></span> Baja dificultad</span>
                                <span class="chip"><span class="dot"></span> Guía o autoguiado</span>
                            </div>

                            <a href="https://drive.google.com/file/d/14siL30Br98rio2v-2iaEIDrZ0sTG2rK2/view?usp=sharing"
                                target="_blank" class="btn btn-accent btn-lg">Consultar salida</a>
                        </div>
                    </div>
                </div>

                <div class="mt-4 p-4 p-lg-5 border-soft rounded-2xl" style="background: rgba(112,185,255,.08);">
                    <div class="d-flex align-items-center gap-2 mb-2">
                        <span class="d-inline-block rounded-circle"
                            style="width:10px;height:10px;background:var(--link)"></span>
                        <h3 class="h4 mb-0">Información importante</h3>
                    </div>
                    <p class="text-muted-2 mb-3">
                        Antes de realizar los senderos, te pedimos que te informes sobre condiciones generales y
                        requisitos mínimos
                        requeridos por el área de Turismo de la Estancia Funke.
                    </p>
                    <a class="btn btn-ghost btn-lg"
                        href="https://drive.google.com/drive/folders/1x2zQq3Ycb_Ey32HgETcnfieA34Uk9BOX" target="_blank"
                        rel="noopener">
                        Ver requisitos y condiciones
                    </a>
                </div>

            </div>
        </section>


        <!-- TRASLADO -->
        <section id="traslado" class="py-5">
            <div class="container py-3">

                <div class="row align-items-center g-4">
                    <div class="col-12 col-lg-6">
                        <h2 class="display-5 mb-2">Traslado</h2>
                        <p class="text-muted-2 mb-4">
                            Disponemos de un servicio de transporte de pasajeros, de <strong
                                style="color:var(--text)">40 plazas</strong>,
                            con capacidad <strong style="color:var(--text)">4x4</strong> que posibilita el
                            acceso cuando los caminos se tornan
                            intransitables para colectivos de ruta o vehículos de tracción simple.
                        </p>

                        <div class="d-flex gap-2 flex-wrap mb-4">
                            <span class="chip"><span class="dot"></span> 40 plazas</span>
                            <span class="chip"><span class="dot"></span> 4x4</span>
                            <span class="chip"><span class="dot"></span> Tornquist ↔ Refugio</span>
                        </div>

                        <div class="p-3 border-soft rounded-2xl mb-4" style="background: rgba(255,255,255,.03);">
                            <div class="text-muted-2" style="font-size:.95rem;">
                                Se puede contratar de manera anticipada para garantizar el ingreso o egreso de
                                los grupos, desde Tornquist
                                hasta el Refugio.
                            </div>
                        </div>

                        <a href="#como-llegar" class="btn btn-ghost btn-lg px-4">Ver cómo llegar</a>
                    </div>

                    <div class="col-12 col-lg-6">
                        <div class="p-3 p-lg-4 bg-panel border-soft rounded-2xl shadow-soft">
                            <div class="d-flex align-items-center justify-content-between mb-3">
                                <h3 class="h4 mb-0">Foto</h3>
                                <span class="text-muted-2" style="font-size:.95rem;">Servicio de traslado</span>
                            </div>
                            <img class="w-100 border-soft rounded-2xl" alt="Traslado Refugio Napostá"
                                src="@/assets/viewlanding/Colectivo 4x4/Colectivo 1.jpeg">
                        </div>
                    </div>
                </div>

            </div>
        </section>


        <!-- CÓMO LLEGAR -->
        <section id="como-llegar" class="py-5 topo-sep">
            <div class="container py-3">

                <div class="text-center mb-4">
                    <h2 class="display-5 mb-2">Cómo llegar</h2>
                    <p class="text-muted-2 mb-0" style="max-width: 980px; margin: 0 auto;">
                        El refugio se encuentra en la Estancia "Rodolfo Funke". La ciudad más cercana es
                        Tornquist, a 21 km por caminos de tierra.
                        El estado de los caminos puede variar según las precipitaciones.
                    </p>
                </div>

                <div class="row g-4 align-items-stretch">
                    <div class="col-12 col-lg-7">
                        <div class="p-3 p-lg-4 bg-panel border-soft rounded-2xl shadow-soft h-100">
                            <div class="d-flex align-items-center justify-content-between mb-3">
                                <h3 class="h4 mb-0">Mapa</h3>
                            </div>
                            <div class="ratio ratio-16x9 border-soft rounded-2xl overflow-hidden">
                                <iframe
                                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2988.3947314645657!2d-62.02425435939574!3d-38.116543367250834!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x95ecf4decf57de3f%3A0xed9b937693ca0430!2sRefugio%20Naposta!5e1!3m2!1ses-419!2sar!4v1769526807119!5m2!1ses-419!2sar"
                                    width="600" height="450" style="border:0;" allowfullscreen="" loading="lazy"
                                    referrerpolicy="no-referrer-when-downgrade"></iframe>
                            </div>
                        </div>
                    </div>

                    <div class="col-12 col-lg-5">
                        <div class="p-4 p-lg-5 bg-panel border-soft rounded-2xl shadow-soft h-100">
                            <h3 class="h4 mb-3">Recomendaciones</h3>

                            <div class="p-3 border-soft rounded-2xl mb-3" style="background: rgba(255,106,0,.08);">
                                <div class="fw-semibold mb-1">⚠️ Estado de caminos</div>
                                <div class="text-muted-2">
                                    El estado de los caminos suele ser variable de acuerdo a las
                                    precipitaciones. Informate antes de salir.
                                </div>
                            </div>

                            <div class="p-3 border-soft rounded-2xl mb-4" style="background: rgba(76,201,166,.08);">
                                <div class="fw-semibold mb-1">📍 Paso a paso</div>
                                <ol class="text-muted-2 mb-0 ps-3">
                                    <li>Llegá a Tornquist.</li>
                                    <li>Buscá "Refugio Napostá" en Google Maps desde tu celular.</li>
                                    <li>Seguí el track indicado sin cerrar la aplicación.</li>
                                </ol>
                            </div>

                            <div class="d-flex gap-2 flex-column flex-sm-row">
                                <a href="#reservas" class="btn btn-accent btn-lg px-4">Consultar visita</a>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="mt-5">
                    <div class="d-flex align-items-end justify-content-between flex-wrap gap-2 mb-3">
                        <h3 class="h3 mb-0">Camino y acceso</h3>
                        <div class="text-muted-2">Imágenes de referencia</div>
                    </div>

                    <div class="row g-3">
                        <div class="col-12 col-md-6">
                            <a class="d-block" target="_blank" href="img/Como llegar/1.jpg">
                                <img class="w-100 border-soft rounded-2xl" alt="Cómo llegar 1"
                                    src="@/assets/viewlanding/Como llegar/1.jpg">
                            </a>
                        </div>
                        <div class="col-12 col-md-6">
                            <a class="d-block" target="_blank" href="img/Como llegar/2.jpg">
                                <img class="w-100 border-soft rounded-2xl" alt="Cómo llegar 2"
                                    src="@/assets/viewlanding/Como llegar/2.jpg">
                            </a>
                        </div>
                    </div>
                </div>

            </div>
        </section>


        <!-- TARIFAS -->
        <section id="tarifas" class="py-5">
            <div class="container py-3">

                <div class="row align-items-end g-4 mb-4">
                    <div class="col-12 col-lg-7">
                        <h2 class="display-5 mb-2">Tarifas</h2>
                        <p class="text-muted-2 mb-0">
                            Nuestras tarifas son accesibles y están diseñadas para grupos. Consultanos para
                            recibir el tarifario
                            actualizado y coordinar tu visita.
                        </p>
                    </div>
                    <div class="col-12 col-lg-5 text-lg-end">
                        <a href="https://drive.google.com/file/d/1zrf7XEpJF6jrITbIEJI46Q1xoYHJbfeq/view?usp=sharing"
                            target="_blank" class="btn btn-accent btn-lg px-4">Consultar tarifas</a>
                    </div>
                </div>

                <div class="row g-3">
                    <div class="col-12 col-lg-6">
                        <div class="p-3 border-soft rounded-2xl" style="background: rgba(76,201,166,.08);">
                            <div class="fw-semibold mb-1">✅ Incluye</div>
                            <div class="text-muted-2">
                                Acceso a instalaciones, cocina equipada para grupos, agua caliente, duchas,
                                fogones, y provisión de leña (según disponibilidad).
                            </div>
                        </div>
                    </div>

                    <div class="col-12 col-lg-6">
                        <div class="p-3 border-soft rounded-2xl" style="background: rgba(255,106,0,.08);">
                            <div class="fw-semibold mb-1">🚫 No incluye</div>
                            <div class="text-muted-2">
                                Proveeduría · Ropa de cama · Vajilla · Ollas pequeñas
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </section>


        <!-- RESERVAS -->
        <section id="reservas" class="py-5 topo-sep">
            <div class="container py-3">
                <div class="row align-items-end g-4 mb-4">
                    <div class="col-12 col-lg-8">
                        <h2 class="display-5 mb-2">Reservas</h2>
                        <p class="text-muted-2 mb-0">
                            Consultá disponibilidad para tu grupo. Te respondemos para coordinar fechas,
                            condiciones y, si lo necesitan,
                            también el traslado.
                        </p>
                    </div>
                    <div class="col-12 col-lg-4 text-lg-end">
                        <span class="chip"><span class="dot"></span> Respuesta rápida</span>
                    </div>
                </div>

                <div class="row g-3 mb-4">
                    <div class="col-12 col-lg-4">
                        <div class="p-4 bg-panel border-soft rounded-2xl h-100">
                            <div class="d-flex align-items-center gap-2 mb-2">
                                <span class="badge rounded-pill"
                                    style="background: rgba(255,255,255,.06); border: 1px solid var(--stroke); color: var(--text);">1</span>
                                <h3 class="h5 mb-0">Consulta</h3>
                            </div>
                            <p class="text-muted-2 mb-0">
                                Enviá fechas tentativas, cantidad de personas y tipo de grupo.
                            </p>
                        </div>
                    </div>

                    <div class="col-12 col-lg-4">
                        <div class="p-4 bg-panel border-soft rounded-2xl h-100">
                            <div class="d-flex align-items-center gap-2 mb-2">
                                <span class="badge rounded-pill"
                                    style="background: rgba(255,255,255,.06); border: 1px solid var(--stroke); color: var(--text);">2</span>
                                <h3 class="h5 mb-0">Confirmación</h3>
                            </div>
                            <p class="text-muted-2 mb-0">
                                Te confirmamos disponibilidad y condiciones para tu salida.
                            </p>
                        </div>
                    </div>

                    <div class="col-12 col-lg-4">
                        <div class="p-4 bg-panel border-soft rounded-2xl h-100">
                            <div class="d-flex align-items-center gap-2 mb-2">
                                <span class="badge rounded-pill"
                                    style="background: rgba(255,255,255,.06); border: 1px solid var(--stroke); color: var(--text);">3</span>
                                <h3 class="h5 mb-0">Reserva</h3>
                            </div>
                            <p class="text-muted-2 mb-0">
                                Coordinamos la reserva y, si aplica, el pago/seña.
                            </p>
                        </div>
                    </div>
                </div>

                <div class="row g-4 align-items-stretch">
                    <div class="col-12 col-lg-7">

                        <!-- START -->
                        <div v-if="reservasStep == 0" class="position-relative step-1">
                            <div class="container-2 p-3 d-flex flex-column" style="overflow-y: auto;">
                                <h4 class="text-center"><u>Reservas - Refugio Napostá</u></h4>
                                <div>
                                    <label>Apellido y Nombre</label>
                                    <input class="form-control" v-model="apellido_nombre" />
                                    <label class="">Teléfono/Whatsapp</label>
                                    <input class="form-control" type="number" step="1" v-model="telefono" />
                                    <label class="">Email</label>
                                    <input class="form-control" type="text" step="1" v-model="email" />
                                </div>

                                <div class="text-start">
                                    <label for="cantidadPersonas" class="form-label">Cantidad de personas mayores de
                                        10
                                        años</label>
                                    <input type="number" id="cantidadPersonas" v-model="cantidadPersonas"
                                        class="form-control" min="1">
                                </div>

                                <div class="text-start my-1">
                                    <label for="cantidadMenores" class="form-label">Cantidad de menores de 10
                                        años</label>
                                    <input type="number" id="cantidadMenores" v-model="cantidadMenores"
                                        class="form-control" min="0">
                                    <small>(Los menores de 10 años no pagan estadía)</small>
                                </div>

                                <div>
                                    <label>Estadía</label><br />

                                    <input type="radio" id="acampa" value="acampa" name="estadia" v-model="estadia" />
                                    <label for="acampa" class="ms-1">Acampe</label>
                                    <br />
                                    <input type="radio" id="alquila" value="alquila" name="estadia" v-model="estadia" />
                                    <label for="alquila" class="ms-1">Habitación</label>
                                    <br />
                                    <input type="radio" id="alquilaAcampa" value="alquilaAcampa" name="estadia"
                                        v-model="estadia" />
                                    <label for="alquilaAcampa" class="ms-1">Habitación + Acampe</label>
                                    <br />
                                    <button type="button" class="btn btn-primary" data-bs-toggle="modal"
                                        data-bs-target="#reservaModal">
                                        Reservas Exclusivas. Grupos mas de 30 personas
                                    </button>
                                </div>
                                <div>
                                    <button class="btn btn-success float-end mt-2" type="button"
                                        @click="reservasNextStep">Siguiente</button>
                                    <div style="clear: both;"></div>
                                </div>
                            </div>
                        </div>


                        <!-- CALENDAR -->
                        <div v-if="reservasStep == 1" class="position-relative step-2">
                            <div class="container-2" style="overflow-y: auto;">
                                <div class="p-3 px-0" style="height: auto;">

                                    <h3 class="text-white">Seleccioná las noches de estadía</h3>
                                    <ComponentCalendar :fechasDisponibles="fechasDisponibles"
                                        :diasSeleccionados="diasSeleccionados" @toggle-day="handleDayClick" />

                                    <button class="btn btn-primary float-start mt-3 ms-3 btn-ml"
                                        @click="reservasPreviousStep">Volver</button>
                                    <div v-if="diasSeleccionados.length" class="pt-3" style="min-height: 50px;">
                                        <button class="btn btn-success float-end btn-mr me-3" type="button"
                                            @click="reservasNextStep">Siguiente</button>

                                        <!-- Esto no se donde ponerlo -->
                                        <div v-if="false" class="row" style="">
                                            <div v-for="dia in diasSeleccionados" class="col-4 text-center" :key="dia">
                                                <p class="mb-0 text-nowrap" style="">{{ dia }}</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div style="clear: both;"></div>
                                </div>
                            </div>

                        </div>

                        <!-- END -->
                        <div v-if="reservasStep == 2" class="step-3">
                            <div class="container-3 p-3">
                                <div id="carouselHabitaciones" class="carousel slide" data-bs-ride="false">
                                    <div class="carousel-inner">
                                        <div v-for="(dia, index) in diasSeleccionadosDetalle" :key="'dias' + index"
                                            class="carousel-item" :class="{ active: index === 0 }">
                                            <h4 v-if="estadia != 'acampa'" class="text-center m-0">
                                                <u>Seleccione las habitaciones que utilizará</u>
                                            </h4>
                                            <h4 v-else class="text-center m-0"><u>Seleccione la cantidad de personas
                                                    que
                                                    acampan</u></h4>
                                            <div class="text-center mb-2 text-warning" style="font-size: 24px;">{{
                                                dia.fecha.split('-').reverse().join('/') }}</div>

                                            <div class="row">
                                                <div v-if="dia.complejo1 && !dia.lleno1 && (estadia == 'alquila' || estadia == 'alquilaAcampa')"
                                                    class="col-12 col-md-12">
                                                    <div class="form-check form-switch mx-auto"
                                                        style="width: fit-content;">
                                                        <input class="form-check-input" type="checkbox"
                                                            :id="'complejo1' + index"
                                                            v-model="diasSeleccionadosDetalle[index].lugares.complejo1"
                                                            @change="calcularCostoTotal">
                                                        <label :for="'complejo1' + index"
                                                            class="form-check-label">Habitación para 6
                                                            personas</label>
                                                    </div>
                                                </div>
                                                <div v-if="dia.complejo2 && !dia.lleno2 && (estadia == 'alquila' || estadia == 'alquilaAcampa')"
                                                    class="col-12 col-md-12 mt-3">
                                                    <div class="form-check form-switch mx-auto"
                                                        style="width: fit-content;">
                                                        <input class="form-check-input" type="checkbox"
                                                            :id="'complejo2' + index"
                                                            v-model="diasSeleccionadosDetalle[index].lugares.complejo2"
                                                            @change="calcularCostoTotal">
                                                        <label :for="'complejo2' + index"
                                                            class="form-check-label">Habitación para 6
                                                            personas</label>
                                                    </div>
                                                </div>
                                                <div v-if="dia.complejo3 && !dia.lleno3 && (estadia == 'alquila' || estadia == 'alquilaAcampa')"
                                                    class="col-12 col-md-12 mt-3">
                                                    <div class="form-check form-switch mx-auto"
                                                        style="width: fit-content;">
                                                        <input class="form-check-input" type="checkbox"
                                                            :id="'complejo3' + index"
                                                            v-model="diasSeleccionadosDetalle[index].lugares.complejo3"
                                                            @change="calcularCostoTotal">
                                                        <label :for="'complejo3' + index"
                                                            class="form-check-label">Habitación para 9
                                                            personas</label>
                                                    </div>
                                                </div>
                                                <div v-if="dia.complejo4 && !dia.lleno4 && (estadia == 'alquila' || estadia == 'alquilaAcampa')"
                                                    class="col-12 col-md-12 mt-3">
                                                    <div class="form-check form-switch mx-auto"
                                                        style="width: fit-content;">
                                                        <input class="form-check-input" type="checkbox"
                                                            :id="'complejo4' + index"
                                                            v-model="diasSeleccionadosDetalle[index].lugares.complejo4"
                                                            @change="calcularCostoTotal">
                                                        <label :for="'complejo4' + index"
                                                            class="form-check-label">Habitación para 9
                                                            personas</label>
                                                    </div>
                                                </div>
                                                <div v-if="dia.acampe && (cantidadPersonas + cantidadMenores + dia.llenoAcampe) <= dia.cantidadAcampe && (estadia == 'acampa' || estadia == 'alquilaAcampa')"
                                                    class="col-12 col-md-12 mt-3">
                                                    <div v-if="estadia != 'acampa'" class="text-center">
                                                        <label :for="'acampe' + index" class="form-label">Cantidad
                                                            de
                                                            personas en acampe</label>
                                                    </div>
                                                    <!--
                            <div class="text-center">
                            <small>(incluir solo a los mayores de 10 años)</small>
                            </div>
                            -->
                                                    <input class="form-control mx-auto"
                                                        v-model="diasSeleccionadosDetalle[index].lugares.acampe"
                                                        type="number" step="1" style="width: 200px;"
                                                        @keyup="calcularCostoTotal" :id="'acampe' + index"
                                                        @change="calcularCostoTotal" />
                                                </div>
                                            </div>
                                        </div>

                                        <!-- RESUMEN -->
                                        <div class="carousel-item item-reserva">
                                            <h4 class="text-center"><u>Resumen</u></h4>
                                            <div class="table-responsive">
                                                <table class="table">
                                                    <thead>
                                                        <tr>
                                                            <th>Fecha</th>
                                                            <th>Descripcion</th>
                                                            <th>Monto</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr v-for="(detalle, index) in resumen" :key="index">
                                                            <td>{{ detalle.fecha.split('-').reverse().join('/') }}
                                                            </td>
                                                            <td>{{ detalle.title }}</td>
                                                            <td>${{ detalle.monto.toLocaleString() }}</td>
                                                        </tr>
                                                        <tr>
                                                            <td></td>
                                                            <td>{{ cantidadMenores }} menores de 10 años</td>
                                                            <td>$0</td>
                                                        </tr>
                                                        <tr>
                                                            <td></td>
                                                            <td class="text-end"><b>Monto Total</b></td>
                                                            <td>${{ costoTotal.toLocaleString() }}</td>
                                                        </tr>
                                                        <tr>
                                                            <td></td>
                                                            <td class="text-end"><b>Monto de Reserva ({{
                                                                porcentajeReserva }}%):</b></td>
                                                            <td>${{ calcularReserva.toLocaleString() }}</td>
                                                        </tr>
                                                        <tr>
                                                            <td></td>
                                                            <td class="text-end"><b>Monto a pagar al llegar</b></td>
                                                            <td>${{ (costoTotal - calcularReserva).toLocaleString()
                                                                }}
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>

                                            <div class="text-center">
                                                <button v-if="!makingReserva" class="btn btn-success mt-2" type="button"
                                                    @click="reservaStore">Pagar Reserva Ahora</button>
                                                <button v-if="makingReserva" class="btn btn-success mt-2" type="button"
                                                    disabled>
                                                    <div class="spinner-border" role="status">
                                                        <span class="visually-hidden">Loading...</span>
                                                    </div>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class=" mt-2">
                                    <button class="btn btn-primary float-start"
                                        @click="carrouselPrevious">Anterior</button>
                                    <button v-if="indexDiaSeleccionadoResumen != diasSeleccionadosDetalle.length"
                                        class="btn btn-success float-end" @click="carrouselNext">Siguiente</button>
                                    <div style="clear:both;"></div>
                                </div>

                            </div>
                        </div>

                    </div>

                    <div class="col-12 col-lg-5">
                        <div class="p-4 p-lg-5 bg-panel border-soft rounded-2xl shadow-soft h-100">
                            <h3 class="h4 mb-3">Info útil</h3>

                            <div class="p-3 border-soft rounded-2xl mb-3" style="background: rgba(255,255,255,.03);">
                                <div class="fw-semibold mb-1">📌 Qué llevar (básico)</div>
                                <div class="text-muted-2">
                                    Calzado cómodo, abrigo (cambia rápido), linterna, botella de agua y protector solar.
                                </div>
                            </div>

                            <div class="p-3 border-soft rounded-2xl mb-3" style="background: rgba(255,106,0,.08);">
                                <div class="fw-semibold mb-1">⚠️ Caminos</div>
                                <div class="text-muted-2">
                                    El acceso es por caminos de tierra. El estado puede variar según precipitaciones.
                                    Consultá antes de
                                    salir.
                                </div>
                            </div>

                            <div class="p-3 border-soft rounded-2xl mb-3" style="background: rgba(76,201,166,.08);">
                                <div class="fw-semibold mb-1">🔥 Instalaciones</div>
                                <div class="text-muted-2">
                                    Cocina equipada para grupos, salón con salamandra, fogones con parrilla y duchas con
                                    agua caliente 24
                                    hs.
                                </div>
                            </div>

                            <div class="p-3 border-soft rounded-2xl" style="background: rgba(112,185,255,.08);">
                                <div class="fw-semibold mb-1">🚌 Traslado</div>
                                <div class="text-muted-2">
                                    Servicio 40 plazas 4x4 desde Tornquist (opcional). Pedilo en la consulta para
                                    coordinar.
                                </div>
                            </div>

                            <div class="mt-4 d-grid gap-2">
                                <a href="#tarifas" class="btn btn-ghost btn-lg">Ver tarifas</a>
                                <a href="#como-llegar" class="btn btn-ghost btn-lg">Ver cómo llegar</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>


        <!-- CTA FINAL -->
        <section class="py-5 topo-sep">
            <div class="container py-3">
                <div class="p-4 p-lg-5 bg-panel border-soft rounded-2xl shadow-soft text-center">
                    <h3 class="display-6 mb-2">¿Listos para la aventura?</h3>
                    <p class="text-muted-2 mb-4" style="max-width: 900px; margin: 0 auto;">
                        Consultá disponibilidad para tu grupo y organizamos la salida. Si el camino se complica
                        por lluvias,
                        también podés coordinar el traslado 4x4.
                    </p>
                    <div class="d-flex justify-content-center gap-2 flex-column flex-sm-row">
                        <a href="#reservas" class="btn btn-accent btn-lg px-4">Consultar ahora</a>
                        <a href="#como-llegar" class="btn btn-ghost btn-lg px-4">Ver cómo llegar</a>
                    </div>
                </div>
            </div>
        </section>

        <!-- FOOTER -->
        <footer class="py-5" style="border-top: 1px solid var(--stroke); background: rgba(255,255,255,.02);">
            <div class="container py-2">
                <div class="row g-4">

                    <div class="col-12 col-lg-4">
                        <div class="d-flex align-items-center gap-2 mb-2" style="font-weight:800;">
                            <span class="d-inline-block rounded-circle"
                                style="width:10px;height:10px;background:var(--accent2)"></span>
                            Refugio Napostá
                        </div>
                        <p class="text-muted-2 mb-3">
                            Camping y albergue de montaña para grupos. Naturaleza pura, senderos increíbles y base
                            ideal para explorar.
                        </p>
                        <div class="d-flex gap-2 flex-wrap">
                            <a class="btn btn-ghost" href="#reservas">Reservas</a>
                            <a class="btn btn-ghost" href="#experiencias">Experiencias</a>
                        </div>
                    </div>

                    <div class="col-6 col-lg-2">
                        <h4 class="h5 mb-3">Secciones</h4>
                        <ul class="list-unstyled text-muted-2 mb-0">
                            <li class="mb-2"><a href="#nosotros" class="text-decoration-none">Nosotros</a></li>
                            <li class="mb-2"><a href="#experiencias" class="text-decoration-none">Experiencias</a>
                            </li>
                            <li class="mb-2"><a href="#tarifas" class="text-decoration-none">Tarifas</a></li>
                            <li class="mb-2"><a href="#reservas" class="text-decoration-none">Reservas</a></li>
                            <li class="mb-2"><a href="#traslado" class="text-decoration-none">Traslado</a></li>
                            <li><a href="#como-llegar" class="text-decoration-none">Cómo llegar</a></li>
                        </ul>
                    </div>

                    <div class="col-6 col-lg-3">
                        <h4 class="h5 mb-3">Contacto</h4>
                        <ul class="list-unstyled text-muted-2 mb-0">
                            <li class="mb-2">📍 Estancia "Rodolfo Funke"</li>
                            <li class="mb-2">🚗 Cerca de Tornquist (21 km de tierra)</li>
                            <li>📱 WhatsApp: <a class="text-decoration-none"
                                    href="https://api.whatsapp.com/send/?phone=5492932496418&text&type=phone_number&app_absent=0">+5492932496418</a>
                            </li>
                        </ul>
                    </div>

                    <div class="col-12 col-lg-3">
                        <h4 class="h5 mb-3">Aviso</h4>
                        <div class="p-3 border-soft rounded-2xl" style="background: rgba(255,106,0,.08);">
                            <div class="fw-semibold mb-1">Estado de caminos</div>
                            <div class="text-muted-2">
                                Puede variar según precipitaciones. Consultá antes de viajar.
                            </div>
                        </div>
                    </div>

                </div>

                <div class="mt-4 pt-4 text-center text-muted-2" style="border-top: 1px solid var(--stroke);">
                    © <span id="year"></span> Refugio Napostá.
                </div>
            </div>
        </footer>
    </div>
</template>

<script>
import { useToast } from "vue-toastification";
const toast = useToast();
import ComponentCalendar from "@/views/components/client/ComponentCalendar.vue";
//import ComponentLoading from '../components/shared/ComponentLoading.vue';
import { mapActions } from "vuex";
import { Carousel } from 'bootstrap';

export default {
    name: 'ViewLanding',
    mounted() {
        document.getElementById("year").textContent = new Date().getFullYear();
        const link = document.createElement("link");
        link.rel = "stylesheet";
        link.href = "https://fonts.googleapis.com/css2?family=Barlow+Condensed:wght@600;700&family=Inter:wght@400;500;600&display=swap";
        document.head.appendChild(link);
        /*
        new Carousel(document.querySelector('#carouselExample'), {
            ride: 'carousel'
        });
        */
        window.addEventListener('resize', this.updateWidth);

        this.diaHabilitadoGetHabilitados().then(() => { this.loadingStep += 1 });
        this.precioPorcentajeReserva().then(() => { this.loadingStep += 1 });
        this.galeriaGetPhotos().then(() => { this.loadingStep += 1 });
        this.variableGetByName('fondoReservas').then(() => { this.loadingStep += 1 });
        //this.variableGetByName('accesoCerro').then(() => { this.loadingStep += 1 });
        this.variableGetByName('telefono').then(() => { this.loadingStep += 1 });

        this.updateWidth();

    },
    beforeUnmount() {
        window.removeEventListener('resize', this.updateWidth);
    },
    components: {
        ComponentCalendar,
        //ComponentLoading 
    },
    data() {
        return {
            indexDiaSeleccionadoResumen: 0,
            diasSeleccionados: [],
            diasSeleccionadosDetalle: [],
            cantidadPersonas: 1,
            fechasDisponibles: [],
            fechasDisponiblesDetalle: [],
            porcentajeReserva: 0,
            hayMenores: false,
            cantidadMenores: 0,
            reservasStep: 0,
            lugares: {
                complejo1: false,
                complejo2: false,
                complejo3: false,
                complejo4: false,
                acampe: 0
            },
            costos: {
                complejo1: 20000,
                complejo2: 20000,
                complejo3: 40000,
                complejo4: 40000,
                acampe: 10000
            },
            costoTotal: 0,
            resumen: [],
            estadia: '',
            apellido_nombre: '',
            telefono: '',
            telefonoWsp: '',
            email: '',
            photos: [],
            isMobile: false,
            fondoReservas: '',
            loadingStep: 0,
            makingReserva: false,
            accesoCerro: ''
        };
    },
    computed: {
        calcularReserva() {
            return (this.costoTotal * this.porcentajeReserva) / 100;
        }
    },
    watch: {
        estadia() {
            this.calcularDiasDisponibles();
        },
        cantidadPersonas() {
            this.calcularDiasDisponibles();
        },
        cantidadMenores() {
            this.calcularDiasDisponibles();
        }
    },
    methods: {
        enviarWhatsApp() {
            const nombre = document.querySelector('input[placeholder="Tu nombre"]').value.trim();
            //const whatsapp = document.querySelector('input[placeholder="Ej: 11 2345-6789"]').value.trim();
            const personas = document.querySelector('input[placeholder="Ej: 18"]').value.trim();
            const tipo = document.querySelector('select').value;
            const mensaje = document.querySelector('textarea').value.trim();

            let texto = `Hola, quiero consultar disponibilidad en el Refugio Napostá.`;
            if (nombre) texto += `\n*Nombre:* ${nombre}`;
            if (personas) texto += `\n*Personas:* ${personas}`;
            if (tipo && tipo !== "Elegí una opción") texto += `\n*Tipo de grupo:* ${tipo}`;
            if (mensaje) texto += `\n*Mensaje:* ${mensaje}`;

            const url = `https://api.whatsapp.com/send/?phone=5492932496418&text=${encodeURIComponent(texto)}&type=phone_number&app_absent=0`;
            window.open(url, '_blank');
        },
        ...mapActions('reserva', ['reserva_store']),
        ...mapActions('precio', ['precio_getPorcentajeReserva']),
        ...mapActions('diaHabilitado', ['diaHabilitado_getHabilitados']),
        ...mapActions('galeria', ['galeria_getPhotos',]),
        ...mapActions('variable', ['variable_getByName']),
        updateWidth() {
            console.log(window.innerWidth);
            this.isMobile = window.innerWidth <= 767;
        },
        async galeriaGetPhotos() {
            try {
                const response = await this.galeria_getPhotos({ name: 'reservas' });
                console.log('response: ', response)
                this.photos = response.data;
            } catch (error) {
                console.log(error);
                toast.error('Error al obtener las fotos');
            }
        },
        handleDayClick(dia) {
            if (this.diasSeleccionados.includes(dia)) {
                this.diasSeleccionados = this.diasSeleccionados.filter(d => d !== dia);
            } else {
                this.diasSeleccionados.push(dia);
            }
            this.diasSeleccionados = this.diasSeleccionados.sort();
        },
        reservasNextStep() {
            if (this.reservasStep == 1) {
                /*
                if (this.tieneDiasPerdidos()) {
                  toast.error('Su selección de días tiene huecos. Necesitará hacer 2 reservas diferentes sin dias intermedios vacios');
                  return;
                }
                */

                this.diasSeleccionadosDetalle = [];
                this.diasSeleccionados.forEach(dia => {
                    let fechaDisponible = this.fechasDisponiblesDetalle.find(el => el.fecha == dia);

                    fechaDisponible.lugares = {
                        complejo1: false,
                        complejo2: false,
                        complejo3: false,
                        complejo4: false,
                        acampe: this.estadia == 'acampa' ? this.cantidadPersonas + this.cantidadMenores : 0
                    };
                    this.diasSeleccionadosDetalle.push(
                        fechaDisponible
                    );
                    this.calcularCostoTotal();
                });
            }
            if (this.reservasStep == 0) {
                if (!this.apellido_nombre) {
                    toast.error('Debe ingresar un nombre');
                    return;
                }
                if (!this.telefono) {
                    toast.error('Debe ingresar un teléfono');
                    return;
                }

                if (this.cantidadPersonas <= 0) {
                    toast.error('La cantidad de personas mayores debe ser mayor a 0');
                    return;
                }
                if (!this.estadia) {
                    toast.error('Debe seleccionar una opción de estadía');
                    return;
                }
                if (!this.email) {
                    toast.error('Debe ingresar un email');
                    return;
                }
                if (this.cantidadMenores > 5) {
                    toast.error('La cantidad de menores de ser menor o igual a 5')
                    return;
                }
                this.diasSeleccionados = [];
                this.diasSeleccionadosDetalle = [];
            }
            this.reservasStep += 1;
        },
        reservasPreviousStep() {
            if (this.reservasStep != 0) {
                this.reservasStep -= 1;
            }
        },
        calcularCostoTotal() {
            let total = 0;
            let accesoCerro = this.diasSeleccionadosDetalle[0].accesoCerro;
            this.resumen = [];
            this.diasSeleccionadosDetalle.forEach((diaSeleccionadoDetalle) => {

                //console.log('diaSeleccionadoDetalle: ',diaSeleccionadoDetalle);

                if (diaSeleccionadoDetalle.lugares.complejo1) {
                    total += diaSeleccionadoDetalle.monto1;
                    this.resumen.push({
                        title: 'Habitacion 1',
                        fecha: diaSeleccionadoDetalle.fecha.split('-').reverse().join('/'),
                        monto: diaSeleccionadoDetalle.monto1
                    });
                }
                if (diaSeleccionadoDetalle.lugares.complejo2) {
                    total += diaSeleccionadoDetalle.monto2;
                    this.resumen.push({
                        title: 'Habitacion 2',
                        fecha: diaSeleccionadoDetalle.fecha.split('-').reverse().join('/'),
                        monto: diaSeleccionadoDetalle.monto2
                    });
                }
                if (diaSeleccionadoDetalle.lugares.complejo3) {
                    total += diaSeleccionadoDetalle.monto3;
                    this.resumen.push({
                        title: 'Habitacion 3',
                        fecha: diaSeleccionadoDetalle.fecha.split('-').reverse().join('/'),
                        monto: diaSeleccionadoDetalle.monto3
                    });
                }
                if (diaSeleccionadoDetalle.lugares.complejo4) {
                    total += diaSeleccionadoDetalle.monto4;
                    this.resumen.push({
                        title: 'Habitacion 4',
                        fecha: diaSeleccionadoDetalle.fecha.split('-').reverse().join('/'),
                        monto: diaSeleccionadoDetalle.monto4
                    });
                }

                if (diaSeleccionadoDetalle.lugares.acampe) {
                    this.resumen.push({
                        title: diaSeleccionadoDetalle.lugares.acampe + ' personas en acampe',
                        fecha: diaSeleccionadoDetalle.fecha.split('-').reverse().join('/'),
                        monto: diaSeleccionadoDetalle.montoAcampe * diaSeleccionadoDetalle.lugares.acampe
                    });
                    total += diaSeleccionadoDetalle.montoAcampe * diaSeleccionadoDetalle.lugares.acampe;
                }

                if (diaSeleccionadoDetalle.accesoCerro < accesoCerro) {
                    accesoCerro = diaSeleccionadoDetalle.accesoCerro;
                }
            });

            if (accesoCerro) {
                this.resumen.push({
                    title: this.cantidadPersonas + ' Acceso al Cerro',
                    fecha: '',
                    monto: this.cantidadPersonas * accesoCerro
                });

                total += this.cantidadPersonas * accesoCerro;
            }

            this.costoTotal = total + this.cantidadPersonas;

            //this.costoTotal = total * this.diasSeleccionados.length;

        },
        tieneDiasPerdidos() {
            if (this.diasSeleccionados.length < 2) return false;

            let start = this.diasSeleccionados[0];
            let end = this.diasSeleccionados[this.diasSeleccionados.length - 1];

            let indexStart = this.fechasDisponibles.indexOf(start);
            let indexEnd = this.fechasDisponibles.indexOf(end);

            let cantidadRequerida = indexEnd - indexStart + 1;

            if (cantidadRequerida != this.diasSeleccionados.length) {
                return true;
            }

            return false;
        },
        async reservaStore() {
            try {

                let flagCompleto = true;
                let fecha = { fecha: '', faltante: 0 };
                this.diasSeleccionadosDetalle.forEach(diaSeleccionado => {

                    let cantidadSolicitada = 0;
                    if (diaSeleccionado.lugares.complejo1) {
                        cantidadSolicitada += diaSeleccionado.cantidad1;
                    }
                    if (diaSeleccionado.lugares.complejo2) {
                        cantidadSolicitada += diaSeleccionado.cantidad2;
                    }
                    if (diaSeleccionado.lugares.complejo3) {
                        cantidadSolicitada += diaSeleccionado.cantidad3;
                    }
                    if (diaSeleccionado.lugares.complejo4) {
                        cantidadSolicitada += diaSeleccionado.cantidad4;
                    }
                    if (diaSeleccionado.lugares.acampe) {
                        cantidadSolicitada += diaSeleccionado.lugares.acampe;
                    }

                    if (cantidadSolicitada < (this.cantidadPersonas + this.cantidadMenores)) {
                        flagCompleto = false;
                        fecha.fecha = diaSeleccionado.fecha;
                        fecha.faltante = (this.cantidadPersonas + this.cantidadMenores) - cantidadSolicitada;
                    }
                });

                if (!flagCompleto) {
                    toast.error('A la fecha ' + fecha.fecha.split('-').reverse().join('/') + ' le falta asignar ' + fecha.faltante + ' personas');
                    return;
                }

                this.makingReserva = true;

                let response = await this.reserva_store({
                    diasSeleccionadosDetalle: this.diasSeleccionadosDetalle,
                    apellido_nombre: this.apellido_nombre,
                    telefono: this.telefono,
                    email: this.email,
                    costo: this.costoTotal,
                    mayores: this.cantidadPersonas,
                    menores: this.cantidadMenores,
                    porcentajeReserva: this.porcentajeReserva,
                    resumen: this.resumen
                });

                if (response.data.message == 'hack') {
                    toast.success('Reserva hack realizada con éxito');
                    this.$router.push({ name: 'ViewHome' });
                } else if (response.status == 200) {
                    //toast.success('Reserva realizada con éxito');
                    window.location.href = response.data.init_point;
                } else {
                    toast.error('Error haciendo reserva');
                }

            } catch (error) {
                console.log(error);
                toast.error('Error haciendo reserva');
            }
        },
        async diaHabilitadoGetHabilitados() {
            try {
                let response = await this.diaHabilitado_getHabilitados({ client: true });
                console.log('diaHabilitadoGetHabilitados: ', response);
                if (response.status == 200) {

                    this.fechasDisponiblesDetalle = response.data.diasHabilitados;


                }
            } catch (error) {
                console.log(error);
                toast.error('Error obteniendo dias habilitados');
            }
        },
        async precioPorcentajeReserva() {
            try {
                let response = await this.precio_getPorcentajeReserva();

                if (response.status == 200) {
                    this.porcentajeReserva = response.data.porcentaje_reserva.value;
                }
            } catch (error) {
                console.log(error);
                toast.error('Error obteniendo el porcentaje de reserva');
            }
        },
        carrouselNext() {
            let carouselInstance = new Carousel(document.getElementById('carouselHabitaciones'));
            let lugaresOcupados = 0;
            if (this.diasSeleccionadosDetalle[this.indexDiaSeleccionadoResumen].lugares.complejo1) {
                lugaresOcupados += this.diasSeleccionadosDetalle[this.indexDiaSeleccionadoResumen].cantidad1;
            }
            if (this.diasSeleccionadosDetalle[this.indexDiaSeleccionadoResumen].lugares.complejo2) {
                lugaresOcupados += this.diasSeleccionadosDetalle[this.indexDiaSeleccionadoResumen].cantidad2;
            }
            if (this.diasSeleccionadosDetalle[this.indexDiaSeleccionadoResumen].lugares.complejo3) {
                lugaresOcupados += this.diasSeleccionadosDetalle[this.indexDiaSeleccionadoResumen].cantidad3;
            }
            if (this.diasSeleccionadosDetalle[this.indexDiaSeleccionadoResumen].lugares.complejo4) {
                lugaresOcupados += this.diasSeleccionadosDetalle[this.indexDiaSeleccionadoResumen].cantidad4;
            }
            if (this.diasSeleccionadosDetalle[this.indexDiaSeleccionadoResumen].lugares.acampe) {
                lugaresOcupados += this.diasSeleccionadosDetalle[this.indexDiaSeleccionadoResumen].lugares.acampe;
            }

            if (lugaresOcupados < (this.cantidadPersonas)) {
                toast.error("La selección no completa la cantidad personas");
            } else {
                carouselInstance.next();
                this.indexDiaSeleccionadoResumen += 1;
            }
        },
        carrouselPrevious() {
            if (this.indexDiaSeleccionadoResumen == 0) {
                this.reservasStep -= 1;
            } else {
                let carouselInstance = new Carousel(document.getElementById('carouselHabitaciones'));
                carouselInstance.prev();
                this.indexDiaSeleccionadoResumen -= 1;
            }

        },
        calcularDiasDisponibles() {
            this.fechasDisponibles = [];
            console.log('this.estadia',this.estadia);
            this.fechasDisponiblesDetalle.forEach(fechaDisponible => {

                let cantidad = this.cantidadMenores + this.cantidadPersonas;

                let cantidadAlquilaAcampa = 0;
                if (fechaDisponible.complejo1 && !fechaDisponible.lleno1) cantidadAlquilaAcampa += fechaDisponible.cantidad1;
                if (fechaDisponible.complejo2 && !fechaDisponible.lleno2) cantidadAlquilaAcampa += fechaDisponible.cantidad2;
                if (fechaDisponible.complejo3 && !fechaDisponible.lleno3) cantidadAlquilaAcampa += fechaDisponible.cantidad3;
                if (fechaDisponible.complejo4 && !fechaDisponible.lleno4) cantidadAlquilaAcampa += fechaDisponible.cantidad4;
                if (fechaDisponible.acampe) cantidadAlquilaAcampa += fechaDisponible.cantidadAcampe - fechaDisponible.llenoAcampe;

                let cantidadAlquila = 0;
                if (fechaDisponible.complejo1 && fechaDisponible.lleno1 == 0) cantidadAlquila += fechaDisponible.cantidad1;
                if (fechaDisponible.complejo2 && fechaDisponible.lleno2 == 0) cantidadAlquila += fechaDisponible.cantidad2;
                if (fechaDisponible.complejo3 && fechaDisponible.lleno3 == 0) cantidadAlquila += fechaDisponible.cantidad3;
                if (fechaDisponible.complejo4 && fechaDisponible.lleno4 == 0) cantidadAlquila += fechaDisponible.cantidad4;

                let cantidadAcampa = fechaDisponible.cantidadAcampe - fechaDisponible.llenoAcampe;

                let habilitado = true;

                console.log('fecha', fechaDisponible.fecha);
                console.log('cantidad: ',cantidad);
                console.log('cantidadAcampa: ',cantidadAcampa);
                console.log('fechaDisponible.acampe: ',fechaDisponible.acampe);
                if (this.estadia == 'acampa') {
                    if (cantidad > cantidadAcampa || !fechaDisponible.acampe) {
                        habilitado = false;
                    }
                }

                console.log('cantidadAlquilaAcampa: ',cantidadAlquilaAcampa);
                if (this.estadia == 'alquilaAcampa') {
                    if (cantidad > cantidadAlquilaAcampa) {
                        habilitado = false;
                    }
                }

                if (this.estadia == 'alquila') {
                    if (cantidad > cantidadAlquila) {
                        habilitado = false;
                    }
                }

                if (habilitado) {
                    this.fechasDisponibles.push(fechaDisponible.fecha);
                } else {
                    this.fechasDisponibles.push('!' + fechaDisponible.fecha);
                }
            });
        },
        async variableGetByName(nombre) {
            try {
                let response = await this.variable_getByName({ nombre: nombre });

                if (response.status == 200) {
                    if (nombre == 'telefono') {
                        this.telefonoWsp = response.data.value;
                    } else {
                        this[nombre] = response.data.value;
                    }
                }

            } catch (error) {
                console.log(error);
                toast.error('Error obteniendo variable');
            }
        },
    },

};
</script>

<style scoped>
.landing {
    font-family: Inter, system-ui, -apple-system, Segoe UI, Roboto, Arial, sans-serif;
    background: #0b0f12;
    color: #e9eef3;
}

h1,
h2,
h3,
h4 {
    font-family: "Barlow Condensed", Inter, sans-serif;
    letter-spacing: .5px;
}

.text-muted-2 {
    color: rgba(233, 238, 243, .72) !important;
}

.border-soft {
    border: 1px solid rgba(233, 238, 243, .14) !important;
}

.bg-panel {
    background: rgba(17, 24, 32, .85);
}

.rounded-2xl {
    border-radius: 1.25rem;
}

.shadow-soft {
    box-shadow: 0 18px 50px rgba(0, 0, 0, .35);
}

.btn-accent {
    background: #ff6a00;
    border-color: #ff6a00;
    color: #0b0f12;
    font-weight: 700;
}

.btn-accent:hover {
    filter: brightness(.95);
}

.btn-ghost {
    border: 1px solid rgba(233, 238, 243, .14);
    background: rgba(255, 255, 255, .03);
    color: #e9eef3;
    font-weight: 600;
}

.btn-ghost:hover {
    background: rgba(255, 255, 255, .06);
}

.chip {
    display: inline-flex;
    align-items: center;
    gap: .5rem;
    padding: .4rem .7rem;
    border: 1px solid rgba(233, 238, 243, .14);
    border-radius: 999px;
    background: rgba(255, 255, 255, .03);
    color: rgba(233, 238, 243, .72);
    font-size: .9rem;
}

.dot {
    width: .55rem;
    height: .55rem;
    border-radius: 999px;
    background: #4cc9a6;
    display: inline-block;
}

.topo-sep {
    position: relative;
    overflow: hidden;
}

.topo-sep:before {
    content: "";
    position: absolute;
    inset: -60px -60px auto -60px;
    height: 220px;
    background:
        radial-gradient(closest-side, rgba(255, 255, 255, .06), transparent 70%),
        radial-gradient(closest-side, rgba(255, 255, 255, .05), transparent 70%);
    filter: blur(2px);
    opacity: .6;
    pointer-events: none;
}

a {
    color: #70b9ff;
}

a:hover {
    opacity: .9;
}

.navbar {
    backdrop-filter: blur(10px);
    background: rgba(11, 15, 18, .65) !important;
    border-bottom: 1px solid rgba(233, 238, 243, .14);
}

.hero {
    min-height: 100vh;
    position: relative;
    display: grid;
    place-items: center;
    padding-top: 80px;
    overflow: hidden;
}

.video-bg {
    position: absolute;
    inset: 0;
    z-index: 0;
    overflow: hidden;
}

.video-bg iframe {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 120vw;
    height: 120vh;
    transform: translate(-50%, -50%);
    pointer-events: none;
}

.hero-overlay {
    position: absolute;
    inset: 0;
    background: rgba(11, 15, 18, .75);
    z-index: 1;
}

.hero-content {
    position: relative;
    z-index: 2;
}

.hero-mobile {
    position: relative;
    background:
        linear-gradient(to bottom,
            rgba(11, 15, 18, .85),
            rgba(11, 15, 18, .92)),
        url("https://refugionaposta.com.ar/refugio/api-refugio/storage/photos/8fff3acc-5eac-4128-af3c-f4c1b38b7efd.jpg");
    background-size: cover;
    background-position: center;
    padding-top: 80px;
    padding-bottom: 24px;
}

.hero-mobile::before {
    content: "";
    position: absolute;
    inset: 0;
    background: inherit;
    filter: blur(20px);
    transform: scale(1.08);
    z-index: 0;
}

.hero-mobile>* {
    position: relative;
    z-index: 1;
}

.hero-mobile-video {
    position: relative;
    border-radius: 16px;
    overflow: hidden;
    box-shadow: 0 20px 60px rgba(0, 0, 0, .6);
    background-image:
        linear-gradient(to bottom, rgba(11, 15, 18, .35), rgba(11, 15, 18, .65)),
        url("https://refugionaposta.com.ar/refugio/api-refugio/storage/photos/8fff3acc-5eac-4128-af3c-f4c1b38b7efd.jpg");
    background-size: cover;
    background-position: center;
}

.hero-mobile-video::before {
    content: "";
    position: absolute;
    inset: 0;
    background: inherit;
    filter: blur(18px);
    transform: scale(1.08);
    z-index: 0;
    opacity: .85;
}

.hero-mobile-video .yt-cover {
    position: relative;
    z-index: 1;
    overflow: hidden;
}

.hero-mobile-video .yt-cover iframe {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 140%;
    height: 140%;
    transform: translate(-50%, -50%);
    pointer-events: none;
}

.hero-mobile-video::after {
    content: "";
    position: absolute;
    inset: 0;
    z-index: 2;
    pointer-events: none;
    background:
        linear-gradient(to bottom, rgba(11, 15, 18, .75), transparent 20%),
        linear-gradient(to top, rgba(11, 15, 18, .75), transparent 20%);
}

.titulo {
    font-family: 'Barlow Condensed', sans-serif;
}

.texto {
    font-family: 'Inter', sans-serif;
}

h1,
h2,
h3,
h4,
h5,
h6 {
    color: white;
}

a {
    color: rgba(255, 255, 255, 0.55);
}

.reservas-panel {
    color: var(--text);
}

.reservas-panel label {
    color: var(--muted);
    font-size: .9rem;
}

.reservas-panel small {
    color: var(--muted);
}

.reservas-panel input,
.reservas-panel select,
.reservas-panel textarea {
    background: transparent;
    border: 1px solid var(--stroke);
    color: var(--text);
}

.reservas-panel input:focus,
.reservas-panel select:focus,
.reservas-panel textarea:focus {
    border-color: var(--accent);
    box-shadow: none;
}

.reservas-panel .form-control {
    background: transparent;
    border: 1px solid var(--stroke);
    color: var(--text);
}

.reservas-panel .form-control::placeholder {
    color: var(--muted);
}

.reservas-panel .btn-primary {
    background: var(--accent);
    border-color: var(--accent);
    color: #0b0f12;
    font-weight: 600;
}

.reservas-panel .btn-primary:hover {
    filter: brightness(.95);
}

.reservas-panel .btn-success {
    background: var(--accent2);
    border-color: var(--accent2);
    color: #0b0f12;
    font-weight: 600;
}

.reservas-panel .btn-success:hover {
    filter: brightness(.95);
}

.reservas-panel .btn-outline-secondary {
    border: 1px solid var(--stroke);
    background: rgba(255, 255, 255, .03);
    color: var(--text);
}

.reservas-panel .btn-outline-secondary:hover {
    background: rgba(255, 255, 255, .06);
}

.reservas-panel .table {
    color: var(--text);
}

.reservas-panel .table th {
    border-bottom: 1px solid var(--stroke);
    color: var(--muted);
}

.reservas-panel .table td {
    border-color: rgba(255, 255, 255, .05);
}

.reservas-panel h3,
.reservas-panel h4 {
    font-family: "Barlow Condensed", sans-serif;
    letter-spacing: .5px;
}

.carousel-inner {
    background: transparent;
}

.container-2 {
    font-family: 'Poppins', sans-serif;
    color: white;
}

.container-2 h4,
.container-2 label,
.container-3 h4 {
    font-family: 'Poppins', sans-serif;
    color: white;

}

.container-3 th {
    background-color: #8B572A;
}

.container-3 td {
    background-color: #A66A3A;
}

.container-3 td,
.container-3 th {
    color: white;
}

table {
    border: 1px black solid;
}

.container-3 {
    width: 400px;
    margin-left: auto;
    margin-right: auto;
    ;
    font-family: 'Poppins', sans-serif;
    color: white;
}

.slider {
    height: calc(100vh - 125px);
}

h3 {
    text-align: center;
    color: #3a3a3a;
}

.dias-seleccionados-container {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    /* Espacio entre elementos */
}

.dia-seleccionado {
    background-color: #e0e0e0;
    padding: 5px 10px;
    border-radius: 5px;
    white-space: nowrap;
    /* Evita que los textos se dividan en dos líneas */
}

.overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    /* Ajusta la opacidad (0.5 es 50%) */
}

.bg-white {
    background-color: whitesmoke !important;
}

.general-container {
    width: 100vw;
    margin-left: calc(-1 * (100vw - 100%));
    /* Ajusta el margen para contrarrestar el scroll */
}

.general-container .col-md-6 {
    padding-left: 0;
    padding-right: 0;
}

@media (max-width: 767px) {
    .col-12 {
        
    }

    .step-1 {
        
    }

    .step-2 {
        
    }

    .step-2 .container-2 {
        
        
    }

    .item-reserva {}

    .container-2 {
        
    }

    .container-2 h4,
    .container-2 label,
    .container-3,
    .container-3 h4 {
        text-align: center;
    }

    .container-3 {
        
    }

    .slider {
        
    }

    .btn-ml {
        margin-left: 10px;
    }

    .btn-mr {
        margin-right: 10px;
    }
}

@media (min-width: 768px) {

    .step-1 .container-2,
    .step-2 .container-2,
    .step-3 .container-3 {
        
    }

    .step-2 .container-2 {
        
    }

    .step-1,
    .step-2,
    .step-3 {
        
    }

    .item-reserva {
        overflow-y: auto;
    }

    .step-3 .container-3 {
        
    }
}

button {
    font-size: 0.8rem;
}
</style>